import { compose, filter, get, size, some } from 'lodash/fp';
import { createSelector } from 'reselect';
import { flow } from 'fp-ts/function';
import { createPropsExtender, composeProps, ifProps } from '@mews/framework';
import { gtOne, getStringProp, getProp } from '@mews/fp';
import { RouteName } from '@mews-commander/enums';
import { ResolveRoute } from '@mews/routing';
import { createOptionsSelector, mapId } from '@mews-commander/utils';
import {
    composeServiceIdFromProps,
    getEnterpriseActiveServices,
    getEnterpriseBookableServices,
    getEnterpriseProductServices,
    getService,
    getServiceEnterpriseId,
    serviceCreateOptionsProps,
} from '../ducks/services';
import { localizedEntities } from '../ducks/utils';
import { getEnterprises, getEnterpriseSubscriptionId } from '../ducks/enterprises';
import { currentEnterpriseIdPropsExtender } from './session/enterprise';

export const getCurrentEnterpriseBookableServices = composeProps(
    ifProps(['enterpriseId'], getEnterpriseBookableServices),
    currentEnterpriseIdPropsExtender
);

// @ts-expect-error $TSFixMeError: No overload matches this call.
export const getCurrentEnterpriseBookableServicesIds = createSelector(getCurrentEnterpriseBookableServices, mapId);

export const hasCurrentEnterpriseMultipleBookableServices = compose(gtOne, size, getCurrentEnterpriseBookableServices);

export const getCurrentEnterpriseServiceOptions = createOptionsSelector(
    // @ts-expect-error
    localizedEntities(getCurrentEnterpriseBookableServices, 'names', 'localizedName'),
    serviceCreateOptionsProps
);

export const getCurrentEnterpriseActiveServices = composeProps(
    ifProps(['enterpriseId'], getEnterpriseActiveServices),
    currentEnterpriseIdPropsExtender
);

export const getCurrentEnterpriseProductServices = composeProps(
    ifProps(['enterpriseId'], getEnterpriseProductServices),
    currentEnterpriseIdPropsExtender
);

export const getLocalizedCurrentEnterpriseProductServices = localizedEntities(
    // @ts-expect-error
    getCurrentEnterpriseProductServices,
    'names',
    'localizedName'
);

const getCurrentEnterpriseOfferedProductServices = compose(
    filter(['options.offerToEmployee', true]),
    getCurrentEnterpriseProductServices
);

export const getCurrentEnterpriseProductServiceOptions = createOptionsSelector(
    // @ts-expect-error
    localizedEntities(getCurrentEnterpriseOfferedProductServices, 'names', 'localizedName'),
    serviceCreateOptionsProps
);

// @ts-expect-error $TSFixMeError: Argument of type '(state: ApplicationState, props: unknown) => ExtendedProp<"enterpriseId", string>' is not assignable t...
export const getCurrentEnterpriseService = composeProps(getService, currentEnterpriseIdPropsExtender);

const getServiceEnterprise = createSelector(getServiceEnterpriseId, getEnterprises, get);

export const getServiceIdEnterprise = composeServiceIdFromProps(getServiceEnterprise);

export const getServiceIndexUrl = createSelector(
    getProp<ResolveRoute>()('resolveRoute'),
    getStringProp('enterpriseId'),
    (resolveRoute, enterpriseId) => resolveRoute(RouteName.ServiceIndex, { query: { OwnerId: enterpriseId } })
);

export const hasAnyCurrentEnterpriseBookableServiceSkipCleaningEnabled = compose(
    some((service) => (service as $TSFixMe).data.value.visitOptions.enableSkipCleaning || false),
    getCurrentEnterpriseBookableServices
);

export const getServiceEnterpriseIanaTimeZoneIdentifier = flow(getServiceIdEnterprise, get('timeZoneIdentifier'));

export const getServiceEnterpriseEditableHistoryIntervalMilliseconds = flow(
    getServiceIdEnterprise,
    get('editableHistoryIntervalMilliseconds')
);

export const getServiceEnterpriseSubscriptionId = composeProps(
    getEnterpriseSubscriptionId,
    createPropsExtender('enterpriseId', getServiceEnterpriseId)
);
